import { Component, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { INotification } from '../interfaces/notification';
import { NotificationsService } from '../services/notifications.service';

@Component({
  selector: 'app-modal-notification',
  templateUrl: './modal-notification.component.html',
  styleUrls: ['./modal-notification.component.css']
})
export class ModalNotificationComponent implements OnInit {
  @Input() notification: INotification;

  constructor(
    private modal: NgbActiveModal,
    private toastr: ToastrService,
    private notificationService: NotificationsService
  ) { }

  ngOnInit() {
    if (!this.notification.IsRead) {
      this.markAsRead(this.notification, false);
    }
  }

  close() {
    this.modal.close()
  }

  markAsRead(message: INotification, close: boolean) {
    this.notificationService.markAsRead([message.Id]).subscribe(
      () => {
        message.IsRead = true;
        if (close) this.close();
      },
      error => {
        this.toastr.error("Error", null, {
          positionClass: 'toast-top-right',
          timeOut: 2000
        })
      });
  }

  markAsUnRead(message: INotification) {
    this.notificationService.markAsUnRead([message.Id]).subscribe(
      () => {
        message.IsRead = false;
        this.close();
      },
      error => {
        this.toastr.error("Error", null, {
          positionClass: 'toast-top-right',
          timeOut: 2000
        })
      });
  }
}
